import { DomainsGoogleVerificatedAutocomplete } from '@/modules/Domains';
import { Button, Col, Flex, Row, Typography } from 'antd';
import { FC } from 'react';

interface Props {
  isIndexingPageLoading: boolean;
  siteId: string;
  domainIds: string[];
  errors: Record<string, string> | null;
  handleChangeDomainIds: (value: string[]) => void;
  handleIndexingPage: () => void;
}

export const SearchConsoleIndexingFormView: FC<Props> = ({
  isIndexingPageLoading,
  siteId,
  domainIds,
  errors,
  handleChangeDomainIds,
  handleIndexingPage
}) => {
  return (
    <Row wrap gutter={ [0, 16] } style={{ width: '100%' }}>
      <Col span={ 24 }>
        <Flex wrap>
          <DomainsGoogleVerificatedAutocomplete
            disabled={ isIndexingPageLoading }
            loading={ isIndexingPageLoading }
            style={{ width: '100%' }}
            siteId={ siteId }
            onChange={ handleChangeDomainIds }
            value={ domainIds }
          />
          { errors?.domainIds && <Typography.Text type="danger">{ errors.domainIds }</Typography.Text> }
        </Flex>
      </Col>
      <Col span={ 24 }>
        <Button
          onClick={ handleIndexingPage }
          type="default"
          block
          disabled={ isIndexingPageLoading }
          loading={ isIndexingPageLoading }
        >
          Відправити
        </Button>
      </Col>
    </Row>
  );
};
